export const NegativeAdGroupDsaTarget = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Ad Group Negative Dynamic Search Ad Target',
    },
  },
};
